import * as React from 'react';
import { cn } from '@/lib/utils';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'outline' | 'beta' | 'preview';
}

const variantStyles: Record<string, string> = {
  default: 'bg-primary text-primary-foreground border-transparent',
  outline: 'bg-background text-foreground',
  beta: 'bg-amber-500/10 text-amber-500 border-amber-500/20 text-[9px] font-semibold uppercase tracking-wide',
  preview: 'bg-violet-500/10 text-violet-500 border-violet-500/20 text-[9px] font-semibold uppercase tracking-wide',
};

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium',
        variantStyles[variant] || variantStyles.default,
        className
      )}
      {...props}
    />
  );
}
